import React from 'react';
import Modal from 'react-modal';
import update from 'immutability-helper';
import moment from 'moment'

import { financial } from '../../core/controllers/Financial';
import { modalStyles } from '../../core/controllers/ModalStyles';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { tenantBilling } from '../../core/controllers/TenantBilling';
import { billing } from '../../core/controllers/Billing';
import { modal } from '../../core/utilities/modal';
import { user } from '../../core/controllers/user';

import FeesList from '../../components/Fees/FeesList';
import PropertiesSelect from '../../components/Properties/PropertiesSelect';
import LeaseSelect from '../../components/Leases/LeaseSelect';
import OwnersSelect from '../../helpers/Owner/OwnersSelect';
import WorkOrdersSelect from '../../helpers/WorkOrders/WorkOrdersSelect';
import InvoicesSelect from '../../helpers/Invoices/InvoicesSelect';
import FeesSelect from '../../helpers/Fees/FeesSelect';
import NavLink from '../../components/Routes/NavLink';
import CardHolder from '../../helpers/Cards/CardHolder';
import { Income, Expense, LateRent } from '../../helpers/Cards/Cards';
import DotProgress from '../../core/utilities/DotProgress';
import { TabGroup } from '../../helpers/Tabs/TabGroup';
import { Tab } from '../../helpers/Tabs/Tab';

// import QuickBooksTable from '../../components/QuickBooks/QuickBooksActions';
export default class FinancialTemplate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            income: 0,
            expense: 0,
            generalActive: 'active',
            quickBooksActive: '',
            feesActive: '',
            transactionsActive: '',
            showModal: false,
            transactionHistory: null,
            newTransaction: false,
            transactionData: {
                transactionId: 0,
                title : '',
                description: '',
                amount: 0,
                type: 0,
                positive: 'positive',
                property_id: 0,
                contract_id: 0,
                work_order_id: 0,
                invoice_id: 0,
                owner_id: 0,
                fee_id: 0,
            },
            hasIncomeData: true,
            hasExpensesData: true,
            showDateModal: false,
            newDate: null,
            startDate: moment(moment().subtract(30, 'day').format("YYYY-MM-DD")),
            endDate: moment(moment().format("YYYY-MM-DD")),
            currentTabIndex: 0,
        }
        this.index = 0;
        this.options = {
            defaultSortName: 'created_at',  // default sort column name
            defaultSortOrder: 'desc'  // default sort order
        };
    }

    componentDidMount() {
        var self = this
        this.getTransactionHistory();
        this.getChartData();
        jQuery('.daterange').daterangepicker({
            opens: 'center',
            "startDate": self.state.startDate,
            "endDate": self.state.endDate,
            "showDropdowns": true,
            "drops": "down",
            "minYear": Number(moment().format("YYYY")) - 3,
            "maxYear": Number(moment().format("YYYY")),
            "locale": {
                "format": 'MMM Do, YYYY'
            }
        },  function(start, end) {
            self.onDateRangePick(start, end)
        });
    }

    getChartData() {
        var self = this;
        financial.getChartData(
            this.state.startDate,
            this.state.endDate,
            function (response) {
                self.processIcomeChartData(response);
            }
        );
        financial.getChartData(
            this.state.startDate,
            this.state.endDate,
            function (response) {
                self.processExpenseChartData(response);
            }, 'expense'
        );
    }

    processIcomeChartData(response) {
        const data          = response.data.chartData;
        var incomeData      = [[], []];

        if (data) {
            var keys            = Object.keys(data);
            var allMonths = ['Jan','Feb','Mar', 'Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
            keys.sort(function(a,b){
                return allMonths.indexOf(a) - allMonths.indexOf(b);
            });

            keys.forEach(key => {
                const keyData       = data[key];
                const daysOfMonth   = Object.keys(keyData);
                var amount          = 0;
                if (Array.isArray(daysOfMonth)) {
                    daysOfMonth.forEach(day => {
                        keyData[day].forEach(transaction => {
                            if (!isNaN(transaction.amount)) {
                                amount += transaction.amount
                            }
                        })
                    });
                    incomeData[0].push(key);
                    incomeData[1].push(amount)
                } else {
                    incomeData[0].push(key);
                    incomeData[1].push(keyData.amount)
                }
            });
        }
        this.createIncomeChart(incomeData);
    }

    processExpenseChartData(response) {
        const data          = response.data.chartData;
        var expenseData      = [[], []];
        if (data) {
            var keys            = Object.keys(data);
            var allMonths = ['Jan','Feb','Mar', 'Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
            keys.sort(function(a,b){
                return allMonths.indexOf(a) - allMonths.indexOf(b);
            });

            keys.forEach(key => {
                const keyData       = data[key];
                const daysOfMonth   = Object.keys(keyData);
                var amount          = 0;
                if (Array.isArray(daysOfMonth)) {
                    daysOfMonth.forEach(day => {
                        keyData[day].forEach(transaction => {
                            if (!isNaN(transaction.amount)) {
                                amount += transaction.amount
                            }
                        })
                    });
                    expenseData[0].push(key);
                    expenseData[1].push(amount)
                } else {
                    expenseData[0].push(key);
                    expenseData[1].push(keyData.amount)
                }
            });
        }
        this.createExpenseChart(expenseData);
    }

    createIncomeChart(incomeData) {
        if (incomeData[0].length > 0) {
            this.setState({
                hasIncomeData: true
            });

            const labels = incomeData[0]
            const incomeValues = incomeData[1]
            const canvas = document.getElementById('income_chart');
            if (canvas !== null) {
                const ctx    = canvas.getContext('2d');

                const gradientIncome = ctx.createLinearGradient(0, 0, 0, 250);
                gradientIncome.addColorStop(0, 'rgba(58, 155, 242, 0.5)');
                gradientIncome.addColorStop(0.5, 'rgba(58, 155, 242, 0.25)');
                gradientIncome.addColorStop(1, 'rgba(58, 155, 242, 0)');

                var chart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels: labels,
                        datasets: [{
                            label: 'Income',
                            data: incomeValues,
                            backgroundColor: gradientIncome,
                            pointBackgroundColor: '#0078FF',
                            borderColor: '#0078FF',
                            borderWidth: 3
                        }]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: true,
                        animation: {
                            easing: 'easeInOutQuad',
                            duration: 520
                        },
                        scales: {
                            xAxes: [{
                                gridLines: {
                                    color: 'rgba(200, 200, 200, 0.05)',
                                    lineWidth: 1
                                }
                            }],
                            yAxes: [{
                                gridLines: {
                                    color: 'rgba(200, 200, 200, 0.08)',
                                    lineWidth: 1
                                },
                                ticks: {
                                    beginAtZero: true,
                                    callback: function(value,index,array) { return (value < 1000000) ? value/1000 + 'K' : value/1000000 + 'M'; }
                                }
                            }]
                        },
                        elements: {
                            line: {
                                tension: 0.4
                            }
                        },
                        legend: {
                            display: true,
                            position: "bottom",
                            align: "start",
                            labels: {
                                fontFamily: 'Open Sans',
                                fontSize: 15,
                                boxWidth: 32,
                                padding: 50,
                            },
                        },
                        point: {
                            backgroundColor: 'white'
                        },
                        tooltips: {
                            titleFontFamily: 'Open Sans',
                            backgroundColor: 'rgba(0,0,0,0.3)',
                            titleFontColor: '#070F29',
                            caretSize: 5,
                            cornerRadius: 2,
                            xPadding: 10,
                            yPadding: 10
                        }
                    }
                });
            }
        } else {
            this.setState({
                hasIncomeData: false
            })
        }
    }

    createExpenseChart(expenseData) {
        if (expenseData[0].length > 0) {
            this.setState({
                hasExpensesData: true
            });

            const labels = expenseData[0]
            const expenseValues = expenseData[1]
            const canvas = document.getElementById('expense_chart');
            if (canvas !== null) {
                const ctx    = canvas.getContext('2d');

                const gradientExpenses = ctx.createLinearGradient(0, 0, 0, 250);
                gradientExpenses.addColorStop(0, 'rgba(243, 30, 22, 0.5)');
                gradientExpenses.addColorStop(0.5, 'rgba(243, 30, 22, 0.25)');
                gradientExpenses.addColorStop(1, 'rgba(243, 30, 22, 0)');

                var chart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels: labels,
                        datasets: [{
                            label: 'Expenses',
                            data: expenseValues,
                            backgroundColor: gradientExpenses,
                            pointBackgroundColor: '#F31E16',
                            borderColor: '#F31E16',
                            borderWidth: 3
                        }]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: true,
                        animation: {
                            easing: 'easeInOutQuad',
                            duration: 520
                        },
                        scales: {
                            xAxes: [{
                                gridLines: {
                                    color: 'rgba(200, 200, 200, 0.05)',
                                    lineWidth: 1
                                }
                            }],
                            yAxes: [{
                                gridLines: {
                                    color: 'rgba(200, 200, 200, 0.08)',
                                    lineWidth: 1
                                },
                                ticks: {
                                    beginAtZero: true,
                                    callback: function(value,index,array) { return (value < 1000000) ? value/1000 + 'K' : value/1000000 + 'M'; }
                                }
                            }]
                        },
                        elements: {
                            line: {
                                tension: 0.4
                            }
                        },
                        legend: {
                            display: true,
                            position: "bottom",
                            align: "start",
                            labels: {
                                fontFamily: 'Open Sans',
                                fontSize: 15,
                                boxWidth: 32,
                                padding: 50,
                            },
                        },
                        point: {
                            backgroundColor: 'white'
                        },
                        tooltips: {
                            titleFontFamily: 'Open Sans',
                            backgroundColor: 'rgba(0,0,0,0.3)',
                            titleFontColor: '#070F29',
                            caretSize: 5,
                            cornerRadius: 2,
                            xPadding: 10,
                            yPadding: 10
                        }
                    }
                });
            }
        } else {
            this.setState({
                hasExpensesData: false
            })
        }
    }

    onDateRangePick(start, end) {
        this.setState({
            startDate: start,
            endDate: end
        });

        this.getTransactionHistory();

        if (this.state.generalActive == 'active') {
            this.getChartData();
        }

        this.reload();
    }

    reload() {
        this.forceUpdate();
    }

    handleOpenModal(value) {
        if (value == "add_transaction") {
            this.setState ({
                newTransaction: true,
            });
            this.refresh();
        } else {
            this.setState ({
                newTransaction: false,
            });
            this.updateTransactionData(value);
        }
        this.setState({ showModal: true });
    }

    handleOpenTenantModal(value) {
        if (value == "add_transaction") {
            this.setState ({
                newTransaction: true,
            });
            this.refresh();
        } else {
            this.setState ({
                newTransaction: false,
            });
            this.updateTransactionData(value);
        }
        this.setState({ showModal: true });
    }
    updateTransactionData(value) {
        var self = this;
        financial.getTransaction(value.transaction_id,function(response) {
            var money = response.data.charge / 100;
            var positive = 'negative';
            if(money > 0) {
                positive = 'positive';
            }
            self.setState({
                transactionData: update(self.state.transactionData, {
                    transactionId: {$set: value.transaction_id},
                    title: {$set: response.data.title},
                    description: {$set: response.data.description},
                    amount: {$set: money},
                    type: {$set: response.data.transaction_type},
                    positive: {$set: positive},
                    property_id: {$set: response.data.property_id},
                    contract_id: {$set: response.data.contract_id},
                    work_order_id: {$set: response.data.work_order_id},
                    invoice_id: {$set: response.data.invoice_id},
                    owner_id: {$set: response.data.owner_id},
                    fee_id: {$set: response.data.fee_id},
                }),
            });
        });
    }

    handleCloseModal(hasUpdated) {
        if (hasUpdated == true) {
            this.getTransactionHistory();
        }
        this.refresh();
        this.setState({
            showModal: false,
            showDateModal: false
        });
        this.reload();
    }

    getTransactionHistory() {
        var self = this;
        financial.getTransactionHistory(
            this.state.startDate,
            this.state.endDate,
            function(response) {
                self.setState({
                    transactionHistory: self.formatTransactions(response.data),
                    showModal: false,
                    showDateModal: false
                });
        });
    }

    /**
     * Formats money, if not value, return 0
     * @param {*} e
     */
    formatAmount(value) {
        // format money
        var money = parseFloat(value);
        if(isNaN(money) || money === 0) {
            money = 0;
        } else {
            money = money / 100;
        }

        return money;
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    formatMoney(cell, row) {
        var money = this.formatAmount(cell);
        var cssClass = "positive";
        if(money < 0) {
            cssClass = "negative";
        }


        money = Number(money.toFixed(2)).toLocaleString()
        money.toLocaleString("en-US", {style:"currency", currency:"USD"});

        return "<span class='table-"+cssClass+"'>$"+money+"</span>";
    }

    formatDate(cell, row) {
        return moment(cell).format('D MMM YYYY');
    }

    formatDescription(cell, row) {
        if(row.description == null){
            if(row.is_rent_payment == 1) {
                return 'Automated Rent Payment';
            } else if(row.is_rent_payment == 0) {
                return 'Automated Tenant Payment';
            }
        } else {
            return row.description;
        }
    }

    formatTitle(cell, row) {
        if(row.is_rent_payment == 1) {
            return 'Paid Rent';
        } else if(row.is_rent_payment == 0) {
            return 'Tenant Payment';
        } else {
            return row.title;
        }
    }

    formatUser(cell, row) {
        if(row.isTenantTrans) {
            return <NavLink to={"/tenant/" + row.tenant_id}>{row.tenant_firstname + ' ' + row.tenant_lastname}</NavLink>
        } else {
            return 'N/A'
        }
    }

    formatActionOptions(cell, row) {
        if (row.isTenantTrans) {
            return (
                <span>
                {/* <span>
                    <i class="fa fa-pencil-square-o download-invoice" onClick={this.handleOpenTenantModal.bind(this, row)}></i>
                </span> */}
                { row.status != 'PAID' && (
                <span onClick={this.markAsPaid.bind(this, row)}>
                    <i class="pe-7s-check download-invoice"></i>
                </span>
                )}
                { row.status == 'IN_PROCESS' && row.is_credit_card == false && (
                <span onClick={this.voidTenantTransaction.bind(this, row)}>
                    <i class="pe-7s-close-circle download-invoice"></i>
                </span>
                )}
                { row.status == 'NONE' && user.userInfo.user_type_alias != 'tenant' && (
                <span onClick={this.deleteTenantTransaction.bind(this, row)}>
                    <i class="pe-7s-close-circle download-invoice"></i>
                </span>
                )}
                </span>
            )
        } else {
            return (
                <span>
                    <i class="fa fa-pencil-square-o download-invoice" onClick={this.handleOpenModal.bind(this, row)}></i>
                </span>
            )
        }
    }

    handleTitleChange(e){
        this.setState({
            transactionData: update(this.state.transactionData, {
                title: {$set: e.target.value}
            }),
        });
    }

    handleDescriptionChange(e){
        this.setState({
            transactionData: update(this.state.transactionData, {
                description: {$set: e.target.value}
            }),
        });
    }

    handleAmountChange(e){
        var money = e.target.value;
        var positive = 'negative';
        if(money > 0) {
            positive = 'positive';
        }

        this.setState({
            transactionData: update(this.state.transactionData, {
                amount: {$set: money},
                positive: {$set: positive}
            }),
        });
    }

    handleTypeChange(e){
        this.setState({
            transactionData: update(this.state.transactionData, {
                type: {$set: e.target.value}
            }),
        });
    }

    refresh() {
        this.setState({
            transactionData: update(this.state.transactionData, {
                transactionId: {$set: 0},
                title: {$set: ''},
                description: {$set: ''},
                amount: {$set: 0},
                type: {$set: 0},
                positive: {$set: 'positive'},
                property_id: {$set: 0},
                contract_id: {$set: 0},
                work_order_id: {$set: 0},
                invoice_id: {$set: 0},
                owner_id: {$set: 0},
                fee_id: {$set: 0},
            })
        });
    }

    addTransaction(e){
        var self = this;
        var transactionAmount = this.state.transactionData.amount.toString().replace(',', '').replace('.', '');

        if(!this.state.transactionData.title) {
            modal.showInfo("Please enter a title.", "danger", "top", "center");
            return;
        }
        if (transactionAmount === undefined || transactionAmount <= 0) {
            modal.showInfo("Please enter an amount for this transaction.", "danger", "top", "center");
            return false;
        } else if (isNaN(transactionAmount)) {
            modal.showInfo("Please enter a valid transaction amount.", "warning", "top", "center");
            return false;
        }

        financial.addTransaction(this.state.transactionData, function(response) {
            modal.showInfo("Transaction Added!", "success", "top", "center");
            self.handleCloseModal(true);
        });
    }

    updateTransaction(e) {
        var self = this;
        var transactionAmount = this.state.transactionData.amount.toString().replace(',', '').replace('.', '');

        if(!this.state.transactionData.title) {
            modal.showInfo("Please enter a title.", "danger", "top", "center");
            return;
        }
        if (transactionAmount === undefined || transactionAmount <= 0) {
            modal.showInfo("Please enter an amount for this transaction.", "danger", "top", "center");
            return false;
        } else if (isNaN(transactionAmount)) {
            modal.showInfo("Please enter a valid transaction amount.", "warning", "top", "center");
            return false;
        }

        financial.updateTransaction(this.state.transactionData, function(response) {
            modal.resetBackDrop();
            modal.showInfo("Transaction has been updated.", "success", "top", "center");
            self.handleCloseModal(true);
        });
    }

    deleteTransaction(e) {
        var self = this;
        financial.deleteTransaction(this.state.transactionData.transactionId, function(response) {
            modal.resetBackDrop();
            modal.showSuccess('Transaction deleted!', 'Transaction has been removed.');
            jQuery(".move-on").on('click',function() {
                self.handleCloseModal(true);
            });
        });
    }

    handlePropertyChange(e) {
        var value = e.target.value;

        this.setState({
            transactionData: update(this.state.transactionData, {
                property_id: {$set: value}
            }),
        });
    }

    handleLeaseChangeChange(e) {
        var value = e.target.value;

        this.setState({
            transactionData: update(this.state.transactionData, {
                contract_id: {$set: value}
            }),
        });
    }

    handleWorkOrderChange(e) {
        var value = e.target.value;

        this.setState({
            transactionData: update(this.state.transactionData, {
                work_order_id: {$set: value}
            }),
        });
    }

    handleInvoiceChange(e) {
        var value = e.target.value;

        this.setState({
            transactionData: update(this.state.transactionData, {
                invoice_id: {$set: value}
            }),
        });
    }

    handleOwnerChange(e) {
        var value = e.target.value;

        this.setState({
            transactionData: update(this.state.transactionData, {
                owner_id: {$set: value}
            }),
        });
    }

    handleFeeChange(e) {
        var value = e.target.value;

        this.setState({
            transactionData: update(this.state.transactionData, {
                fee_id: {$set: value}
            }),
        });
    }

    formatStatus(cell, row) {
        if (!row.isTenantTrans) {
            return '<span class="important-small-green">Paid</span>';
        }

        var status = <DotProgress dotPos={2} date={row.due_at}/>
        if (cell == 'PAID') {
            status = <DotProgress dotPos={3} date={row.due_at}/>
        } else if (cell == 'VOID') {
            status = '<span class="important-small-gray">Cancelled</span>';
        } else if (cell == 'EXPIRED') {
            status = '<span class="important-small-red">Expired</span>';
        } else if (cell == 'FAILED') {
            status = '<span class="important-small-red">Failed</span>';
        } else if (cell == 'REFUNDED') {
            status = '<span class="important-small-blue">Refund</span>';
        } else if (cell == 'NONE') {
            status = <DotProgress dotPos={1} date={row.due_at}/>
        }

        return status;
    }

    formatDateAndClick(cell, row) {
        if (row.status == 'NONE' && user.userInfo.user_type_alias != 'tenant') {
            if (cell == null) {
                return (
                    <span onClick={this.changeDate.bind(this, row)}>
                        Not Set&nbsp;
                        <i class="pe-7s-pen download-invoice"></i>
                    </span>
                )
            } else {
                return (
                    <span onClick={this.changeDate.bind(this, row)}>
                        {moment(cell).format('D MMM YYYY')}&nbsp;
                        <i class="pe-7s-pen download-invoice"></i>
                    </span>
                )
            }
        } else {
            if (cell == null) {
                return (
                    <span>
                        Not Set&nbsp;
                    </span>
                )
            } else {
                return moment(cell).format('D MMM YYYY');
            }
        }
    }

    changeDate(transaction) {
        this.setState({showDateModal: true, selectedTransaction: transaction});
    }

    handleNewDueDate(e) {
        this.setState({
            newDate: e.target.value
        });
    }

    voidTenantTransaction(invoice) {
        var self = this;
        modal.showDangerModalWithOK("Cancel Payment", "Are you sure you want to cancel this payment?", "Cancel");
        jQuery(".move-on").on('click',function() {
            billing.voidTransaction(invoice, function(){
                modal.showInfo("Payment was cancelled.", "success", "top", "center");
                self.getTransactionHistory();
            });
        });
    }

    deleteTenantTransaction(invoice) {
        var self = this;
        modal.showDangerModalWithOK("Cancel Payment", "Are you sure you want to cancel this payment?", "Cancel");
        jQuery(".move-on").on('click',function() {
            tenantBilling.deleteTransaction(invoice, function(){
                modal.showInfo("Payment was cancelled.", "success", "top", "center");
                self.getTransactionHistory();
            });
        });
    }

    markAsPaid(invoice) {
        var self = this;
        modal.showDangerModalWithOK("Mark Paid", "Are you sure you want to mark this invoice as paid?", "Continue");
        jQuery(".move-on").on('click',function() {
            tenantBilling.markInvoicePaid(invoice, function(){
                modal.showInfo("Invoice marked as paid.", "success", "top", "center");
                self.getTransactionHistory();
            });
        });
    }

    updatePaymentDate(invoice) {
        var self        = this;
        const newDate   = this.state.newDate;

        if(newDate == null) {
            modal.showInfo("Select a new payment due date.", "warning", "top", "center");
            return false;
        }

        modal.showDangerModalWithOK("Update Payment Due Date", "Are you sure you want to update the payment due date?", "Yes");
        jQuery(".move-on").on('click',function() {
            tenantBilling.updatePaymentDate(invoice, newDate, function(){
                modal.showInfo("Payment due date was updated.", "success", "top", "center");
                self.getTransactionHistory();
            });
        });
    }

    formatTransactions(transactionHistory) {
        var formattedTransactions = [];
        if(transactionHistory != null) {
            transactionHistory.forEach(transaction => {
                const history = transaction.history;
                const details = transaction.details;
                var transactionType = "";

                if (transaction.isTenantTrans) {
                    if (history.is_security_deposit == 1) {
                        transactionType = "Security Deposit"
                    } else if (history.is_pet_deposit == 1) {
                        transactionType = "Pet Deposit"
                    } else if (history.is_rent_payment == 1) {
                        transactionType = "Rent Payment"
                    } else if (history.transaction_type == 1) {
                        transactionType = "Maintenence"
                    }  else if (history.transaction_type == 2) {
                        transactionType = "Other"
                    }  else if (history.transaction_type == 3) {
                        transactionType = "Fee"
                    } else if (history.transaction_type == 4) {
                        transactionType = "Owner Payout"
                    } else if (history.transaction_type == 5) {
                        transactionType = "Vendor Invoice"
                    } else if (history.transaction_type == 6) {
                        transactionType = "Security Deposit"
                    } else if (history.transaction_type == 7) {
                        transactionType = "Pet Deposit"
                    } else if (history.transaction_type == 8) {
                        transactionType = "Tenant Payout"
                    } else if (history.transaction_type == 9) {
                        transactionType = "Utility"
                    } else if (details.rent == 0 && details.water == 0 && details.disposal == 0 && details.sewage == 0) {
                        if (details.processing_fee == 0) {
                            transactionType = "Other Payment"
                        } else {
                            if (details.charge == details.processing_fee) {
                                transactionType = "Admin/Service Fees"
                            } else {
                                transactionType = "Other Payment + Admin/Service Fees"
                            }
                        }
                    } else {
                        if (details.rent != 0) {
                            if (transactionType == "") {
                                transactionType += "Rent"
                            } else {
                                transactionType += " + Rent"
                            }
                        }
                        if (details.water != 0) {
                            if (transactionType == "") {
                                transactionType += "Water"
                            } else {
                                transactionType += " + Water"
                            }
                        }
                        if (details.disposal != 0) {
                            if (transactionType == "") {
                                transactionType += "Disposal"
                            } else {
                                transactionType += " + Disposal"
                            }
                        }
                        if (details.sewage != 0) {
                            if (transactionType == "") {
                                transactionType += "Sewage"
                            } else {
                                transactionType += " + Sewage"
                            }
                        }
                        if (details.late_rent != 0) {
                            if (transactionType == "") {
                                transactionType += "Late Rent"
                            } else {
                                transactionType += " + Late Rent"
                            }
                        }
                        if (details.processing_fee != 0) {
                            if (transactionType == "") {
                                transactionType += "Admin/Service Fees"
                            } else {
                                transactionType += " + Admin/Service Fees"
                            }
                        }
                    }
                } else if (!transaction.isTenantTrans && details != null && history != null) {
                    transactionType = "";
                    if (details.transaction_type == 0) {
                        transactionType = 'Rent Payment';
                    } else if (details.transaction_type == 1) {
                        transactionType = 'Maintenance';
                    } else if (details.transaction_type == 2) {
                        transactionType = 'Other';
                    } else if (details.transaction_type == 3) {
                        transactionType = 'Fee';
                    } else if (details.transaction_type == 4) {
                        transactionType = 'Owner Payout';
                    } else if(history.is_rent_payment == 1) {
                        transactionType = 'Rent Payment';
                    } else {
                        transactionType = 'Other';
                    }
                }

                if (history == null) {
                    const row =  {
                        transaction_type: transactionType,
                        tenant_payment_history_id: 0,
                        tenant_id: 0,
                        contract_id: 0,
                        is_rent_payment: null,
                        is_security_deposit: null,
                        tenant_transaction_id: transaction.details.tenant_transaction_id,
                        due_at: null,
                        created_at: transaction.details.created_at,
                        charge: transaction.details.charge,
                        rent: transaction.details.rent,
                        water: transaction.details.water,
                        sewage: transaction.details.sewage,
                        processing_fee: transaction.details.processing_fee,
                        transaction_id: transaction.details.transaction_id,
                        title: transaction.details.title,
                        description: transaction.details.description,
                        status: transaction.status,
                        is_credit_card: transaction.is_credit_card,
                        isTenantTrans: false,
                        tenant_lastname: '',
                        tenant_firstname: '',
                        tenant_id: 0
                    }

                    formattedTransactions.push(row);
                } else {
                    const row = {
                        transaction_type: transactionType,
                        tenant_payment_history_id: transaction.history.tenant_payment_history_id,
                        tenant_id: transaction.history.tenant_id,
                        contract_id: transaction.history.contract_id,
                        is_rent_payment: transaction.history.is_rent_payment,
                        is_security_deposit: transaction.history.is_security_deposit,
                        is_pet_deposit: transaction.history.is_pet_deposit,
                        tenant_transaction_id: transaction.details.tenant_transaction_id,
                        due_at: transaction.history.due_at,
                        created_at: transaction.history.created_at,
                        charge: transaction.details.charge,
                        rent: transaction.details.rent,
                        water: transaction.details.water,
                        sewage: transaction.details.sewage,
                        processing_fee: transaction.details.processing_fee,
                        transaction_id: 0,
                        title: '',
                        description: transaction.history.description,
                        status: transaction.status,
                        isTenantTrans: transaction.isTenantTrans,
                        tenant_lastname: transaction.tenant.tenant_lastname,
                        tenant_firstname: transaction.tenant.tenant_firstname,
                        tenant_id: transaction.history.tenant_id,
                        is_credit_card: transaction.is_credit_card,
                        status: transaction.status
                    }

                    formattedTransactions.push(row);
                }
            });
        }
        return formattedTransactions;
    }

    render(){
        var self                    = this;
        const generalActive         = this.state.generalActive;
        const quickBooksActive      = this.state.quickBooksActive;
        const feesActive            = this.state.feesActive;
        const transactionsActive    = this.state.transactionsActive;
        const showDateModal         = this.state.showDateModal;
        var formattedTransactions   = this.state.transactionHistory;
        const newTransaction        = this.state.newTransaction;
        const newDate               = this.state.newDate;
        const selectedTransaction   = this.state.selectedTransaction;
        const startDate             = this.state.startDate.format("MMM Do, YYYY");
        const endDate               = this.state.endDate.format("MMM Do, YYYY");

        const propertyId = this.state.transactionData.property_id;
        const contractId = this.state.transactionData.contract_id;
        const ownerId    = this.state.transactionData.owner_id;
        const invoiceId  = this.state.transactionData.invoice_id;
        const workOrderId = this.state.transactionData.work_order_id;
        const feeId      = this.state.transactionData.fee_id;

        const addTransactionModal = (
            <Modal
                isOpen={this.state.showModal}
                onRequestClose={this.handleCloseModal.bind(this, false)}
                style={modalStyles.getModalStyles()}
                ariaHideApp={false}
            >
            <div class="row">
                <div class="modal-exit-icon pull-right" onClick={this.handleCloseModal.bind(this, false)}></div>
            </div>
            {newTransaction == true ? (
                <div class="row">
                    <div class="modal-header">Add a Transaction</div>
                </div>
            ) : (
                <div class="row">
                    <div class="modal-header">{this.state.transactionData.title}</div>
                </div>
            )}
            <div class="row">
                <div class="modal-section-title col-md-12">Transaction Information</div>
            </div>
            <form>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Title*</label>
                            <input type="text" class="form-control" value={this.state.transactionData.title} name="rentpayment" placeholder="Rent Payment" id="rentpayment" onChange={this.handleTitleChange.bind(this)}/>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Amount*</label>
                            <div class="input-group">
                                <span class="input-group-addon">$</span>
                                <input type="text" class={"form-control " + this.state.transactionData.positive} value={this.state.transactionData.amount} onChange={this.handleAmountChange.bind(this)} placeholder="$0.00" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Transaction Type</label>
                            <select class="form-control" value={this.state.transactionData.type} onChange={this.handleTypeChange.bind(this)}>
                                <option value='0'>Rent Payment</option>
                                <option value='1'>Maintenance Expense</option>
                                <option value='2'>Other</option>
                                <option value='3'>Fee</option>
                                <option value='4'>Owner Payout</option>
                                <option value='6'>Security Deposit</option>
                                <option value='7'>Pet Deposit</option>
                                <option value='8'>Tenant Payout</option>
                                <option value='9'>Utility</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Description</label>
                            <textarea rows="5" cols="80" class="form-control" value={this.state.transactionData.description} placeholder="Description" onChange={this.handleDescriptionChange.bind(this)}/>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="modal-section-title col-md-12" style={{marginBottom: "5px", marginTop: "15px"}}>Associate Transaction</div>
                    <div class="modal-section-content col-md-12" style={{fontSize: "13px"}}>You can associate a transaction to properties, invoices, maintenance, owners, and leases.</div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Select a property</label>
                            <PropertiesSelect columnSize={0} sortID={propertyId} title="" onChange={this.handlePropertyChange.bind(this)} />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Select a lease</label>
                            <LeaseSelect columnSize={0} title="" sortID={contractId} onChange={this.handleLeaseChangeChange.bind(this)} selectIdType={"contract_id"} showAll={false} />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Select an owner</label>
                            <OwnersSelect columnSize={0} sortID={ownerId} title="" onChange={this.handleOwnerChange.bind(this)}/>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Select a maintenance request</label>
                            <WorkOrdersSelect columnSize={0} sortID={workOrderId} title="" onChange={this.handleWorkOrderChange.bind(this)}/>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Select an invoice</label>
                            <InvoicesSelect columnSize={0} sortID={invoiceId} title="" onChange={this.handleInvoiceChange.bind(this)} />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Select a fee</label>
                            <FeesSelect columnSize={0} sortID={feeId} title="" onChange={this.handleFeeChange.bind(this)}/>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="content">
                    { newTransaction === true ? (
                    <div class="col-md-8 col-md-offset-4 col-sm-8 col-sm-offset-4 col-xs-8 col-xs-offset-2">
                        <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.addTransaction.bind(this)}>
                            Create Transaction
                        </button>
                    </div>
                    ) : (
                    <div class="col-md-12">
                        <div class="col-md-3 col-md-offset-2 col-sm-3 col-sm-offset-1 col-xs-6 col-xs-offset-2" style={{padding: 0}}>
                            <button type="button" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill" autoComplete="off" onClick={this.deleteTransaction.bind(this)}>
                                Delete Transaction
                            </button>
                        </div>
                        <div class="col-md-3 col-md-offset-1 col-sm-3 col-sm-offset-2 col-xs-6 col-xs-offset-2" style={{padding: 0, marginTop: window.innerWidth < 768 ? 10 : 0}}>
                            <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.updateTransaction.bind(this)}>
                                Update Transaction
                            </button>
                        </div>
                    </div>
                    )}
                    <div class="clearfix"></div>
                    </div>
                </div>
            </form>
            </Modal>
        );

        const datepicker = <div class="row">
                <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label for="date-range" style={window.innerWidth < 768 ? {color: "black"} : {color: "#FFFFFF"}}>Select Date Range</label>
                        <input 
                            type="button" 
                            class="form-control daterange" 
                            id="daterange" 
                            value={startDate + " - " + endDate} 
                            onChange={this.onDateRangePick.bind(this)} 
                            disabled={false}
                        />
                    </div>
                </div>
            </div>

        return (
        <div class="col-md-12 financial-page">
            <Modal
                isOpen={showDateModal}
                onRequestClose={this.handleCloseModal.bind(this)}
                style={modalStyles.getModalStyles()}
                ariaHideApp={false}>
                <div>
                    <div class="row">
                        <div class="modal-exit-icon pull-right" onClick={this.handleCloseModal.bind(this)}></div>
                    </div>
                    <div class="row">
                        <div class="modal-header">Change Payment Due Date</div>
                    </div>
                    <form>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6 col-md-offset-3">
                                        <div class="form-group">
                                            <label for="assignee">What is the new due date?</label>
                                            <input type="date" class="form-control" onChange={this.handleNewDueDate.bind(this)} value={newDate} placeholder="Select a new payment due date." />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-8 col-md-offset-4 col-sm-8 col-sm-offset-4 col-xs-8 col-xs-offset-3">
                                <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.updatePaymentDate.bind(this, selectedTransaction)}>
                                    Change Date
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </Modal>
            <div class="row">
                <div class="main-page-header-row col-md-12">
                    <div class="col-md-3 col-sm-6 col-xs-12">
                        <span class="main-page-header-title">Financials</span>
                    </div>
                    { (generalActive == 'active' || transactionsActive == 'active') && (
                    <div class="col-md-2 col-md-offset-7 col-sm-6 col-xs-6 col-xs-offset-3 text-center">
                        <button type="button" id="add-transaction" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" autoComplete="off" onClick={this.handleOpenModal.bind(this, "add_transaction")}>
                            Add Transaction
                        </button>
                        <div class="clearfix"></div>
                    </div>
                    )}
                </div>
            </div>
            <br />
            <TabGroup noteActiveTab={index => {
                this.setState({currentTabIndex: index}, (newState) => {
                    this.state.currentTabIndex === 0 && this.getChartData();
                });
            }}>
                <Tab title="overview">
                    <div>
                        {addTransactionModal}
                        {datepicker}
                        <div class="content">
                            <div class="row">
                                <div className="col-md-12">
                                    <CardHolder width="100%" columnCount={3} paddingWidth={15}>
                                        <Income clickable={true} startDate={this.state.startDate} endDate={this.state.endDate}/>
                                        <Expense clickable={true} startDate={this.state.startDate} endDate={this.state.endDate} />
                                        <LateRent clickable={true} startDate={this.state.startDate} endDate={this.state.endDate}/>
                                    </CardHolder>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    {this.state.hasIncomeData == true && (
                                    <div class="card">
                                        <div class="header">
                                            <h4 class="title">Income Trend</h4>
                                            <p class="category"></p>
                                        </div>
                                        <div class="content">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <canvas id="income_chart" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    )}
                                </div>
                                <div class="col-md-6">
                                    {this.state.hasExpensesData == true && (
                                    <div class="card">
                                        <div class="header">
                                            <h4 class="title">Expenses Trend</h4>
                                            <p class="category"></p>
                                        </div>
                                        <div class="content">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <canvas id="expense_chart" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </Tab>
                <Tab title="transactions">
                    <div class="row">
                        {addTransactionModal}
                        {datepicker}
                        <div class="col-md-12">
                            <div class="card">
                                <div class="header">
                                    <h4 class="title">Transaction History</h4>
                                    <p class="category">Complete list of all transactions made.  <small>Payments take 3 - 4 business days.</small></p>
                                </div>
                                <div class="content">
                                    <div>
                                    {formattedTransactions != null ? (
                                        window.innerWidth < 992 ? (
                                        <BootstrapTable data={formattedTransactions} version='4' striped search pagination>
                                            <TableHeaderColumn width="30" dataField='id' dataFormat={this.formatIndexColumn} isKey={ true }></TableHeaderColumn>
                                            <TableHeaderColumn dataField='charge' dataFormat={this.formatMoney.bind(this)} dataSort={ true }>Amount($)</TableHeaderColumn>
                                            <TableHeaderColumn dataField='title' dataFormat={this.formatTitle} dataSort={ true }>Title</TableHeaderColumn>
                                            <TableHeaderColumn dataField='status' dataAlign='center' dataFormat={this.formatStatus.bind(this)} dataSort={ true }>Status</TableHeaderColumn>
                                            <TableHeaderColumn width="35" dataAlign='center' dataFormat={this.formatActionOptions.bind(this)}></TableHeaderColumn>
                                        </BootstrapTable>
                                        ) : (
                                        <BootstrapTable data={formattedTransactions} options={ this.options } version='4' striped search pagination>
                                            <TableHeaderColumn width="100" dataField='id' dataFormat={this.formatIndexColumn} isKey={ true }></TableHeaderColumn>
                                            <TableHeaderColumn dataField='charge' dataFormat={this.formatMoney.bind(this)} dataSort={ true }>Amount($)</TableHeaderColumn>
                                            <TableHeaderColumn dataField='title' dataFormat={this.formatTitle} dataSort={ true }>Title</TableHeaderColumn>
                                            <TableHeaderColumn dataField='description' dataSort={ true } dataFormat={this.formatDescription}>Description</TableHeaderColumn>
                                            <TableHeaderColumn dataField='tenant_lastname' dataFormat={this.formatUser.bind(this)} dataSort={ true }>Paid By</TableHeaderColumn>
                                            <TableHeaderColumn dataField='transaction_type' dataSort={ true }>Type</TableHeaderColumn>
                                            <TableHeaderColumn dataField='status' width="120" dataAlign='center' dataFormat={this.formatStatus.bind(this)} dataSort={ true }>Status</TableHeaderColumn>
                                            <TableHeaderColumn dataField='due_at' width="150" dataFormat={this.formatDateAndClick.bind(this)} dataSort={ true }>Due Date</TableHeaderColumn>
                                            <TableHeaderColumn dataField='created_at' width="150" dataFormat={this.formatDate} dataSort={ true }>Submitted</TableHeaderColumn>
                                            <TableHeaderColumn dataAlign='center' width="100" dataFormat={this.formatActionOptions.bind(this)}></TableHeaderColumn>
                                        </BootstrapTable>
                                        )
                                    ) : (
                                        <p>No transaction history found.</p>
                                    )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Tab>
                {/* <Tab title="quickbooks">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="header">
                                <h4 class="title">QuickBooks Desktop Enterprise</h4>
                                <p class="category"></p>
                            </div>
                             { <QuickBooksTable /> }
                        </div>
                    </div>
                </Tab> */}
                <Tab title="fees">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="header">
                                <h4 class="title">Fee Management</h4>
                                <p class="category">Complete list of all fees</p>
                            </div>
                            <FeesList />
                        </div>
                    </div>
                </Tab>
            </TabGroup>
        </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/Financial/Financial.jsx